import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {Game} from '../../../../shared/model/game';
import {GameCardComponent} from './game-card/game-card.component';
import {GameService} from '../../services/game.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {PaginatedListComponent} from '../../../../shared/components/paginated-list/paginated-list.component';
import {AlertService} from '../../../../shared/services/alert.service';
import {ConfirmDialogService} from '../../../../shared/services/confirm-dialog.service';
import {Messages} from '../../../../shared/constants/messages';
import {PermissionService} from '../../../../core/services/permission.service';
import {SystemPower} from '../../../../shared/model/permissions';
import {BggBulkImportComponent} from '../bgg-bulk-import/bgg-bulk-import.component';

@Component({
  selector: 'app-game-list',
  standalone: true,
  imports: [GameCardComponent, RouterLink, PaginatedListComponent, BggBulkImportComponent],
  templateUrl: './game-list.component.html',
  styleUrl: './game-list.component.css'
})
export class GameListComponent implements OnInit {
  protected games = signal<Array<Game>>([]);
  protected isLoading = signal<boolean>(true);
  private gameService: GameService = inject(GameService);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private alertService: AlertService = inject(AlertService);
  private confirmDialogService: ConfirmDialogService = inject(ConfirmDialogService);
  private permissionService = inject(PermissionService);
  protected bggEnabled: boolean = true;

  protected readonly isMine = computed(() => this.route.snapshot.data['filter'] === 'mine');

  ngOnInit(): void {
    this.loadGames();
  }

  loadGames() {
    this.isLoading.set(true);
    const filter = this.route.snapshot.data['filter'];
    let getGames$;
    if (filter === "mine") {
      getGames$ = this.gameService.getMyGames();
    } else {
      getGames$ = this.gameService.getAllGames();
    }

    getGames$.subscribe({
      next: (games) => {
        this.isLoading.set(false);
        if (games.success && games.data) {
          this.games.set(games.data);
        }
      },
      error: () => {
        this.isLoading.set(false);
      }
    });
  }

  onEditGame(game: Game) {
    this.router.navigate(['/games/edit', game.id]);
  }

  async onDeleteGame(game: Game) {
    const gameId = game.id;
    if (!gameId) {
      return;
    }
    const accepted = await this.confirmDialogService.confirm({
      title: Messages.CONFIRM_GAME_DELETE_TITLE,
      message: Messages.confirmGameDelete(game.gameName),
      confirmLabel: Messages.CONFIRM_DELETE,
    });
    if (!accepted) {
      return;
    }
    this.gameService.deleteGame(gameId).subscribe({
      next: () => {
        this.loadGames();
      },
      error: () => {
        this.isLoading.set(false);
      }
    });
  }

  isLogged() {
    return this.permissionService.isLogged();
  }

  isAdmin() {
    return this.permissionService.hasSystemPower(SystemPower.ADMINISTRATOR);
  }

  onBulkImportCompleted() {
    this.loadGames();
  }
}